import * as actionTypes from './actionsTypes';

export const setiduser = (payload) => {
    return {
        type: actionTypes.SETIDUSER,
        value: payload
    }
}